import type { CompanyHouseCheck as CompanyHouseCheckT } from '@/types/Activity'

interface Props {
  companyHouseCheck: CompanyHouseCheckT
}

const CompanyHouseCheck: React.FC<Props> = ({ companyHouseCheck }) => {
  switch (companyHouseCheck) {
    case 'NotVerified':
      return <p>Not Verified</p>
    case 'Verified':
      return <p>Verified</p>
    case 'Overseas':
      return <p>Overseas</p>
    default:
      return <p></p>
  }
}

export default CompanyHouseCheck
